import styled from 'styled-components'

export const Wrapper = styled.div`
  .header-unread-count {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #fe5147;
    color: #fff;
    text-align: center;
    position: absolute;
    right: 78px;
    bottom: 28px;
    font-size: 10px;
    line-height: 16px;
  }
  .header-unread-count__menu {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #fe5147;
    color: #fff;
    text-align: center;
    position: absolute;
    top: 18px;
    left: 100px;
    font-size: 10px;
    line-height: 16px;
  }  

  .site-menu--user {
    left: 0;
    padding-bottom: 0;
    border-top: 1px solid #DEDEDE;
    position: absolute;
    opacity: 0;
    transform: translateY(-127%);
    transition: transform .25s ease-out;
    top: 100%;
    width: 100%;

    @media (min-width: 768px) {
      left: calc(100% - 320px);
    }
    
    border-bottom: none;
    .accordion-menu__list {
      padding: 12px 0;
      margin-top: 0;
      margin-bottom: 0;
    }
    .accordion-menu__list-control {
      padding: 0;
      display: flex;
      border: none;
      position: relative;
      //padding-top: 16px;
      //padding-bottom: 16px;
      &::before {
        content: none;
      }
      a {
        padding: 16px;
        color: #007acc;
      }
      span {
        position: absolute;
        right: 20px;
        top: 16px;
      }
    }
  }
  .site-menu.is-open {
    opacity: 1;
    transform: translateY(0);
    background-color: #FFF;
    z-index: -2;
  }
`

export const MenuIcon = styled.a`
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  display: inline-flex;
  height: 61px;
  width: 64px;
  text-align: center;
  align-items: center;
  color:  #222223;
  border-left: 1px solid #DEDEDE;

  span {
    font-family: lato;
    font-weight: 700;
    font-size: 11px;
    text-transform: uppercase;
    line-height: 11px;
    margin-bottom: 5px;
  }

  svg.icon {
    margin-left: auto;
    margin-right: auto;
    width: 22px;
    height: 23px;
  }
`
